document.addEventListener('turbolinks:load', () => {
  console.log('Global Javascript Loaded');
});
